import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Rotas from '../rotas/Rotas';
import Apis from '../Apis';

import { FiGrid, FiMapPin, FiUsers, FiPackage, FiCreditCard, FiFileText, FiBriefcase, FiTool, FiGitBranch, FiHash, FiLogOut, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaWhatsapp, FaFacebook, FaInstagram, FaRegHandshake } from 'react-icons/fa';

const W_OPEN   = 240;
const W_CLOSED = 64;
const BAR_H    = 56;

const navItems = [
  { label: 'Home',           icon: <FiGrid size={18} />,         to: '/home' },
  { label: 'Empresa',        icon: <FiBriefcase size={18} />,   to: '/listar-empresas' },
  { label: 'Usuários',       icon: <FiUsers size={18} />,       to: '/listar-usuarios' },
  { label: 'Clientes',       icon: <FiUsers size={18} />,       to: '/listar-clientes' },
  { label: 'Representantes', icon: <FiTool size={18} />,        to: '/listar-representantes' },
  { label: 'Rotas',          icon: <FiGitBranch size={18} />,   to: '/listar-rotas' },
  { label: 'Produtos',       icon: <FiPackage size={18} />,     to: '/listar-produtos' },
  { label: 'Unidades',       icon: <FiHash size={18} />,        to: '/listar-unidades' },
  { label: 'Formas de Pgto', icon: <FiCreditCard size={18} />,  to: '/listar-forma-pagamento' },
  { label: 'Pedidos',        icon: <FiFileText size={18} />,    to: '/listar-pedidos' },
  { label: 'Visitas',        icon: <FiMapPin size={18} />,        to: '/listar-visitas' },
];

const socialItems = [
  { label: 'Facebook',  icon: <FaFacebook size={16} />,  href: Apis.urlFacebook },
  { label: 'WhatsApp',  icon: <FaWhatsapp size={16} />,  href: Apis.urlWhatsapp },
  { label: 'Instagram', icon: <FaInstagram size={16} />, href: Apis.urlInstagram },
];

const BREADCRUMBS = {
  '/home':                    [{ label: 'Home' }],
  '/dashboard':               [{ label: 'Dashboard' }],
  '/listar-produtos':         [{ label: 'Produtos', to: '/listar-produtos' }, { label: 'Listar' }],
  '/cadastrar-produtos':      [{ label: 'Produtos', to: '/listar-produtos' }, { label: 'Listar', to: '/listar-produtos' }, { label: 'Cadastrar' }],
  '/alterar-produto':         [{ label: 'Produtos', to: '/listar-produtos' }, { label: 'Listar', to: '/listar-produtos' }, { label: 'Editar' }],
  '/listar-clientes':         [{ label: 'Clientes', to: '/listar-clientes' }, { label: 'Listar' }],
  '/listar-usuarios':         [{ label: 'Usuários', to: '/listar-usuarios' }, { label: 'Listar' }],
  '/cadastrar-clientes':      [{ label: 'Clientes', to: '/listar-clientes' }, { label: 'Listar', to: '/listar-clientes' }, { label: 'Cadastrar' }],
  '/alterar-cliente':         [{ label: 'Clientes', to: '/listar-clientes' }, { label: 'Listar', to: '/listar-clientes' }, { label: 'Editar' }],
  '/listar-pedidos':          [{ label: 'Pedidos', to: '/listar-pedidos' }, { label: 'Listar' }],
  '/cadastrar-pedido':        [{ label: 'Pedidos', to: '/listar-pedidos' }, { label: 'Listar', to: '/listar-pedidos' }, { label: 'Cadastrar' }],
  '/alterar-pedido':          [{ label: 'Pedidos', to: '/listar-pedidos' }, { label: 'Listar', to: '/listar-pedidos' }, { label: 'Editar' }],
  '/listar-unidades':         [{ label: 'Unidades', to: '/listar-unidades' }, { label: 'Listar' }],
  '/cadastrar-unidade':       [{ label: 'Unidades', to: '/listar-unidades' }, { label: 'Listar', to: '/listar-unidades' }, { label: 'Cadastrar' }],
  '/alterar-unidade':         [{ label: 'Unidades', to: '/listar-unidades' }, { label: 'Listar', to: '/listar-unidades' }, { label: 'Editar' }],
  '/listar-representantes':   [{ label: 'Representantes', to: '/listar-representantes' }, { label: 'Listar' }],
  '/cadastrar-representante': [{ label: 'Representantes', to: '/listar-representantes' }, { label: 'Listar', to: '/listar-representantes' }, { label: 'Cadastrar' }],
  '/alterar-representante':   [{ label: 'Representantes', to: '/listar-representantes' }, { label: 'Listar', to: '/listar-representantes' }, { label: 'Editar' }],
  '/listar-rotas':            [{ label: 'Rotas', to: '/listar-rotas' }, { label: 'Listar' }],
  '/cadastrar-rotas':         [{ label: 'Rotas', to: '/listar-rotas' }, { label: 'Listar', to: '/listar-rotas' }, { label: 'Cadastrar' }],
  '/alterar-rotas':           [{ label: 'Rotas', to: '/listar-rotas' }, { label: 'Listar', to: '/listar-rotas' }, { label: 'Editar' }],
  '/listar-empresas':         [{ label: 'Empresa', to: '/listar-empresas' }, { label: 'Listar' }],
  '/alterar-empresas':        [{ label: 'Empresa', to: '/listar-empresas' }, { label: 'Listar', to: '/listar-empresas' }, { label: 'Editar' }],
  '/listar-forma-pagamento':  [{ label: 'Formas de Pgto', to: '/listar-forma-pagamento' }, { label: 'Listar' }],
  '/cadastrar-forma-pagamento': [{ label: 'Formas de Pgto', to: '/listar-forma-pagamento' }, { label: 'Listar', to: '/listar-forma-pagamento' }, { label: 'Cadastrar' }],
  '/alterar-forma-pagamento': [{ label: 'Formas de Pgto', to: '/listar-forma-pagamento' }, { label: 'Listar', to: '/listar-forma-pagamento' }, { label: 'Editar' }],
  '/listar-visitas':          [{ label: 'Visitas', to: '/listar-visitas' }, { label: 'Listar' }],
};

function getBreadcrumbs(pathname) {
  const exact = BREADCRUMBS[pathname];
  if (exact) return exact;
  const prefix = Object.keys(BREADCRUMBS).find(k => pathname.startsWith(k + '/'));
  return prefix ? BREADCRUMBS[prefix] : [];
}

function Breadcrumb({ pathname, navigate }) {
  const crumbs = getBreadcrumbs(pathname);
  if (!crumbs.length) return null;
  return (
    <nav style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <span style={{ color: '#cbd5e1', fontSize: 13, userSelect: 'none' }}>›</span>
            )}
            {!isLast && c.to ? (
              <button
                onClick={() => navigate(c.to)}
                style={{
                  background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                  fontSize: 13, color: '#94a3b8', fontFamily: 'inherit', fontWeight: 400,
                }}
                onMouseEnter={e => e.currentTarget.style.color = '#475569'}
                onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
              >
                {c.label}
              </button>
            ) : (
              <span style={{ fontSize: 13, color: isLast ? '#1e293b' : '#94a3b8', fontWeight: isLast ? 700 : 400 }}>
                {c.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default function Base({ setToken }) {
  const [open, setOpen] = useState(true);
  const { pathname }    = useLocation();
  const navigate        = useNavigate();

  const nome = localStorage.getItem('nome') || '';

  const handleLogout = () => {
    ['token','email','nome','id','imagemLogin',
     '@adm_pedido_data_ini_pedido','@adm_pedido_data_fim_pedido',
     '@adm_pedido_data_ini_visita','@adm_pedido_data_fim_visita',
    ].forEach(k => localStorage.removeItem(k));
    setToken(null);
    navigate('/');
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh', margin: 0, padding: 0, boxSizing: 'border-box' }}>
      <div style={{
        maxWidth: 1920, margin: '0 auto', minHeight: '100vh',
        display: 'flex',
        boxShadow: '0 0 60px rgba(0,0,0,0.06)',
      }}>

        {/* ── BODY: sidebar + right column ── */}
        <div style={{ display: 'flex', flex: 1 }}>

          {/* Sidebar */}
          <aside style={{
            width: open ? W_OPEN : W_CLOSED,
            flexShrink: 0,
            background: '#0a1520',
            position: 'sticky',
            top: 0,
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'hidden',
            overflowY: 'hidden',
            transition: 'width 0.22s cubic-bezier(0.4,0,0.2,1)',
          }}>

            {/* Brand + toggle */}
            <div style={{
              height: 56, flexShrink: 0,
              display: 'flex', alignItems: 'center',
              padding: open ? '0 10px 0 14px' : '0',
              justifyContent: open ? 'space-between' : 'center',
              borderBottom: '1px solid rgba(255,255,255,0.07)',
              gap: 8,
            }}>
              {open && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, overflow: 'hidden' }}>
                  <div style={{
                    width: 30, height: 30, borderRadius: 8, flexShrink: 0,
                    background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <span style={{ color: '#fff', fontWeight: 800, fontSize: 10, letterSpacing: 0.5 }}>GE</span>
                  </div>
                  <span style={{ color: '#e0e7ff', fontWeight: 700, fontSize: 14.5, letterSpacing: 0.3, whiteSpace: 'nowrap' }}>
                    GE Pedido
                  </span>
                </div>
              )}

              <button
                onClick={() => setOpen(p => !p)}
                style={{
                  width: 28, height: 28, borderRadius: 7, padding: 0, flexShrink: 0,
                  background: 'rgba(255,255,255,0.07)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', color: '#94a3b8',
                  transition: 'background 0.15s, color 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(82,148,181,0.32)'; e.currentTarget.style.color = '#90c3d8'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; e.currentTarget.style.color = '#94a3b8'; }}
              >
                {open ? <FiChevronLeft size={15} /> : <FiChevronRight size={15} />}
              </button>
            </div>

            {/* Nav */}
            <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto', overflowX: 'hidden' }}>
              {navItems.map(item => {
                const active = pathname === item.to;
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    title={!open ? item.label : ''}
                    style={{ textDecoration: 'none', display: 'block', margin: '2px 8px' }}
                  >
                    <div
                      style={{
                        display: 'flex', alignItems: 'center',
                        height: 42, borderRadius: 8,
                        padding: open ? '0 10px' : '0',
                        justifyContent: open ? 'flex-start' : 'center',
                        gap: open ? 10 : 0,
                        background: active ? 'rgba(30,58,76,0.1)' : 'transparent',
                        cursor: 'pointer',
                        transition: 'background 0.15s',
                      }}
                      onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'rgba(82,148,181,0.14)'; }}
                      onMouseLeave={e => { if (!active) e.currentTarget.style.background = active ? 'rgba(30,58,76,0.1)' : 'transparent'; }}
                    >
                      <span style={{ color: active ? '#90c3d8' : '#7c7fa6', display: 'flex', flexShrink: 0 }}>
                        {item.icon}
                      </span>
                      {open && (
                        <span style={{
                          fontSize: 13.5, whiteSpace: 'nowrap',
                          fontWeight: active ? 600 : 400,
                          color: active ? '#e0e7ff' : '#94a3b8',
                        }}>
                          {item.label}
                        </span>
                      )}
                      {active && open && (
                        <div style={{ width: 3, height: 18, borderRadius: 2, background: '#5294b5', marginLeft: 'auto', flexShrink: 0 }} />
                      )}
                    </div>
                  </Link>
                );
              })}
            </nav>

            {/* Divider */}
            <div style={{ height: 1, background: 'rgba(255,255,255,0.07)', margin: '0 8px', flexShrink: 0 }} />

            {/* Social */}
            <div style={{ padding: '8px 0', flexShrink: 0 }}>
              {socialItems.map(item => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  title={!open ? item.label : ''}
                  style={{ textDecoration: 'none', display: 'block', margin: '2px 8px' }}
                >
                  <div
                    style={{
                      display: 'flex', alignItems: 'center',
                      height: 38, borderRadius: 8,
                      padding: open ? '0 10px' : '0',
                      justifyContent: open ? 'flex-start' : 'center',
                      gap: open ? 10 : 0,
                      cursor: 'pointer',
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{ color: '#7c7fa6', display: 'flex', flexShrink: 0 }}>{item.icon}</span>
                    {open && <span style={{ fontSize: 13, color: '#7c7fa6', whiteSpace: 'nowrap' }}>{item.label}</span>}
                  </div>
                </a>
              ))}
            </div>

          </aside>

          {/* Right column: topbar + content */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>

            {/* TOP BAR */}
            <header style={{
              position: 'sticky', top: 0, zIndex: 100, flexShrink: 0,
              height: BAR_H, background: '#fff',
              borderBottom: '1.5px solid #e2e8f0',
              display: 'flex', alignItems: 'center',
              padding: '0 16px', gap: 10,
            }}>
              <div style={{ flex: 1 }}>
                <Breadcrumb pathname={pathname} navigate={navigate} />
              </div>

              {/* User badge */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '4px 12px 4px 5px', borderRadius: 20,
                border: '1.5px solid #e2e8f0', background: '#f8fafc',
              }}>
                <div style={{
                  width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                  background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 12, fontWeight: 700, color: '#fff',
                  userSelect: 'none',
                }}>
                  {nome.charAt(0).toUpperCase() || 'U'}
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#475569', whiteSpace: 'nowrap', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {nome.length > 22 ? `${nome.substring(0, 22)}…` : nome}
                </span>
              </div>

              {/* Logout */}
              <button
                onClick={handleLogout}
                title="Sair"
                style={{
                  width: 36, height: 36, borderRadius: 9, border: 'none', padding: 0,
                  background: 'rgba(239,68,68,0.08)', cursor: 'pointer', color: '#ef4444',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.18)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.08)'}
              >
                <FiLogOut size={16} />
              </button>
            </header>

            {/* Content */}
            <main style={{ flex: 1, background: '#f8fafc', minWidth: 0 }}>
              <Rotas />
            </main>

          </div>

        </div>
      </div>
    </div>
  );
}
